import { jsx as c } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import { e as p } from "./palettes-DoFdaGi8.js";
import { c as u } from "./cn-DlLpp5ix.js";
const b = {
  xs: 6,
  sm: 8,
  md: 10
}, h = f(function({ color: e, tone: o = "neutral", size: a = "sm", className: i, style: n, ...t }, s) {
  const r = !!t["aria-label"], l = b[a], d = e ?? p[o].fg, m = {
    display: "inline-block",
    width: l,
    height: l,
    borderRadius: "var(--radius-full)",
    background: d,
    flexShrink: 0,
    ...n
  };
  return /* @__PURE__ */ c(
    "span",
    {
      ref: s,
      "data-ls-component": "color-dot",
      "data-size": a,
      "data-tone": o,
      role: r ? "img" : void 0,
      "aria-hidden": r ? void 0 : !0,
      className: u(i),
      style: m,
      ...t
    }
  );
});
h.displayName = "ColorDot";
export {
  h as C
};
//# sourceMappingURL=ColorDot-DYvEaW9c.js.map
